module.exports = __webpack_public_path__ + "static/media/designer-de-web.c495f686.svg";